module.exports = __webpack_public_path__ + "img/03.5ddb0d7f.png";